import util from '@bmp-vue/core/api/util'

const controller = 'Empresa'
export default Object.assign({}, util.GetCrud(controller, null), {})
